<cms-unstyled-teaser [content$]="content$" [showIcon]="showIcon" [showTitle]="showTitle" />
